document.addEventListener('DOMContentLoaded', function () {
  function checkAmericana() {
    const checkedColorInput = document.querySelector('input[name="Color"]:checked');
    const ribbon = document.getElementById('americana-ribbon');
    if (!ribbon) return;

    if (checkedColorInput && checkedColorInput.value.trim().toLowerCase() === 'americana') {
      ribbon.style.display = 'inline-block';
    } else {
      ribbon.style.display = 'none';
    }
  }

  checkAmericana();

  document.addEventListener('change', function (e) {
    if (e.target && e.target.name === 'Color') {
      checkAmericana();
    }
  });
});